<template>
  <div class="max-w-screen-xl px-4 mx-auto">
    <div class="flex max-lg:flex-col items-center flex-row-reverse justify-between gap-10 lg:gap-20 lg:*:w-1/2">
      <div class="">
        <p class="text-xl md:text-2xl font-semibold">
          {{ data?.small_heading }}
        </p>
        <h1 class="xl:text-[57px] text-[37px] leading-[1.125] text-white font-bold py-4">
        <WrGradientText :text="data?.main_heading"
          append-class="pb-0 lg:pb-2 bg-clip-text bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_-1.57%,_var(--text-gradient-2)_30.72%)]" />
      </h1>
        <div class="lg:text-xl tracking-[0.5px]" v-html="data?.sub_text"></div>
      </div>
      <div class="w-full max-w-3xl h-auto mx-auto">
        <!-- If image is a webm video -->
        <video v-if="isWebm" :src="props.data?.image"  autoplay muted loop playsinline :width="data?.width ?? 452" :height="data?.height ?? 521"
          class="w-full h-auto [box-shadow:0_2rem_3rem_-1rem_rgba(105,124,161,0.16),0_0_0_0.5rem_#fff] rounded-2xl"></video>

        <!-- Otherwise use NuxtImg -->
        <NuxtImg v-else :src="props.data?.image" alt="Adonis Development Services"
          class="w-full h-auto [box-shadow:0_2rem_3rem_-1rem_rgba(105,124,161,0.16),0_0_0_0.5rem_#fff] rounded-2xl"
          loading="lazy" format="webp" :width="data?.width ?? 452" :height="data?.height ?? 521"/>
      </div>

    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: {
    image?: string;
    heading?: string;
    width?: number;
    height?: number;
  };
}>();
const isWebm = computed(() =>
  props.data?.image?.toLowerCase().endsWith(".webm")
);
</script>
